var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import Auth from "../../containers/Auth";
import { AuthContext } from "../../context/AuthContext";
import { decodingJWT } from "../../utils/jwtDecode";
import { useQuery } from "react-query";
import getAPIMap from "../../api_map";
import axios from "axios";
import getIP from "../../getIP.js";
const IP = getIP();
import { t } from "i18next";
export default function ForwardRoute() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { user } = useContext(AuthContext);
    const { data, isLoading } = useQuery(["/menu", user], () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const url = IP + getAPIMap("menu");
        const config = {
            headers: {
                Authorization: `Bearer ${(_a = user === null || user === void 0 ? void 0 : user.data) === null || _a === void 0 ? void 0 : _a.access_token}`,
            },
        };
        return yield axios.get(url, config);
    }), { enabled: user && ((_a = user === null || user === void 0 ? void 0 : user.data) === null || _a === void 0 ? void 0 : _a.access_token) ? true : false });
    const filteredMenu = (_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.filter((e) => { var _a; return ((_a = Object.keys(e)) === null || _a === void 0 ? void 0 : _a.length) > 0; });
    const firstMenu = ((_e = (_d = filteredMenu === null || filteredMenu === void 0 ? void 0 : filteredMenu[0]) === null || _d === void 0 ? void 0 : _d.subRoutes) === null || _e === void 0 ? void 0 : _e.length)
        ? (_h = (_g = (_f = filteredMenu === null || filteredMenu === void 0 ? void 0 : filteredMenu[0]) === null || _f === void 0 ? void 0 : _f.subRoutes) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.path
        : (_j = filteredMenu === null || filteredMenu === void 0 ? void 0 : filteredMenu[0]) === null || _j === void 0 ? void 0 : _j.path;
    const getRoleName = (user) => {
        var _a, _b, _c, _d, _e;
        let roleName = "";
        roleName = decodingJWT((_a = user === null || user === void 0 ? void 0 : user.data) === null || _a === void 0 ? void 0 : _a.access_token);
        roleName = ((_e = (_d = (_c = (_b = roleName === null || roleName === void 0 ? void 0 : roleName.realm_access) === null || _b === void 0 ? void 0 : _b.roles) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.split("~")) === null || _e === void 0 ? void 0 : _e[2]) || "";
        return roleName;
    };
    return (_jsx(_Fragment, { children: user && ((_k = user === null || user === void 0 ? void 0 : user.data) === null || _k === void 0 ? void 0 : _k.access_token) && !isLoading && firstMenu ? (_jsx(Navigate, { to: getRoleName(user) !== t("_platform_Admin") ? "/app/home" : firstMenu })) : (_jsx(Auth, {})) }));
}
